import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect } from 'react';
import { Routes, Route} from 'react-router-dom';
import Sdk from './sdk/Sdk';
import Home from './pages/Home';
import DemoPatient from './pages/DemoPatient';
import DemoMailSent from './pages/DemoMailSent';
import Medispace from './pages/Medispace';
import MspDomus from './pages/MspDomus';
import OneToOne from './pages/OneToOne';
import Lightbox from './components/Utilities/Lightbox';
import { GlobalModal } from './components/Utilities/Modal';
import CompteRendu from './pages/CompteRendu';

class App extends React.Component 
{
  
  constructor(props) {
    super(props);
    this.state = {
      waitingInitialization: true
    }	
    
    let env, apiUrl;
    /*if(window.location.port == '3000') {
      env = 'dev';
      apiUrl = window.location.host.split(':').shift() + ':3321';
    }

    if(window.location.host.endsWith('invaders.stream')) {
      env = 'dev';
      apiUrl = window.location.host.replace('app', 'api');
    }
      
    window.sdk = new Sdk({
      apiUrl, env
    });*/
  }
 
  async componentDidMount() {
    let res = await window.fetch('/env.json')
    let { apiUrl, env, hocoSettingsUrl } = await res.json();
    window.sdk = new Sdk({
      apiUrl, env, hocoSettingsUrl
    });
    
    await window.sdk.init();
	
    this.setState({
      waitingInitialization: false
    })
  }


  
  render(){
    if(this.state.waitingInitialization)
      return 'waiting...';
      
    return (
      <React.Fragment>
        <Routes>
          <Route exact path='/' element={< Home />}></Route>
          <Route exact path='/demo' element={< DemoPatient />}></Route>
          <Route exact path='/patient' element={< DemoPatient />}></Route>
          <Route exact path='/medispace' element={< Medispace />}></Route>
          <Route exact path='/msp-domus' element={< MspDomus />}></Route>
	        <Route exact path='/mail-sent' element={< DemoMailSent />}></Route>
	        <Route exact path='/compte-rendu' element={< CompteRendu />}></Route>
          <Route exact path='/onetoone/:token/:session' element={< OneToOne />}></Route>
        </Routes>
        <Lightbox />
        <GlobalModal />
      </React.Fragment>
    );
  }

}



export default App;
